if (!customElements.get('search-quickstart')) {
  const RECENT_SEARCHES_KEY = 'arkaneia:recent-searches';
  const RECENT_SEARCHES_MAX = 5;

  const readRecentSearches = () => {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(RECENT_SEARCHES_KEY));
      if (!Array.isArray(parsed)) return [];
      return parsed.filter((term) => typeof term === 'string' && term.trim().length > 0);
    } catch (error) {
      return [];
    }
  };

  const writeRecentSearches = (terms) => {
    try {
      window.localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(terms));
    } catch (error) {
      // Storage unavailable (private browsing) — recent searches silently disabled.
    }
  };

  const renderAllQuickstarts = () => {
    document.querySelectorAll('search-quickstart').forEach((element) => {
      if (typeof element.renderRecent === 'function') element.renderRecent();
    });
  };

  const saveRecentSearch = (term) => {
    const trimmed = (term || '').trim();
    if (!trimmed) return;
    const existing = readRecentSearches().filter(
      (saved) => saved.toLowerCase() !== trimmed.toLowerCase()
    );
    writeRecentSearches([trimmed, ...existing].slice(0, RECENT_SEARCHES_MAX));
  };

  class SearchQuickstart extends HTMLElement {
    connectedCallback() {
      this.recentWrapper = this.querySelector('[data-recent-searches]');
      this.recentList = this.querySelector('[data-recent-list]');
      const clearButton = this.querySelector('[data-clear-recent]');
      if (clearButton) {
        clearButton.addEventListener('click', () => {
          writeRecentSearches([]);
          renderAllQuickstarts();
        });
      }
      this.renderRecent();
    }

    renderRecent() {
      if (!this.recentWrapper || !this.recentList) return;
      const terms = readRecentSearches();
      this.recentWrapper.hidden = terms.length === 0;
      this.recentList.innerHTML = '';
      const searchUrl = this.dataset.searchUrl || '/search';
      terms.forEach((term) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'search-quickstart__chip';
        link.href = `${searchUrl}?q=${encodeURIComponent(term)}&options%5Bprefix%5D=last`;
        link.textContent = term;
        item.appendChild(link);
        this.recentList.appendChild(item);
      });
    }
  }

  customElements.define('search-quickstart', SearchQuickstart);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.getAttribute('role') !== 'search') return;
    const input = form.querySelector('input[name="q"]');
    if (input) saveRecentSearch(input.value);
  });

  document.addEventListener('click', (event) => {
    const suggestion = event.target.closest('.predictive-search a');
    if (!suggestion) return;
    const wrapper = suggestion.closest('predictive-search');
    const input = wrapper && wrapper.querySelector('input[type="search"]');
    if (input) saveRecentSearch(input.value);
  });

  window.addEventListener('pageshow', renderAllQuickstarts);
}
